<template>
  <div
    tabindex="0"
    :class="[
      { 'vld-overlay': true },
      { 'is-active': true },
      { 'is-fixed': rootId === 'app' || rootId === 'root' || rootId === 'micro-common' }
    ]"
    @click.stop="() => {}"
    v-show="isShowLoader"
  >
    <div class="vld-background"></div>
    <div class="vld-icon">
      <div class="s-loader">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
          <g fill="none" fill-rule="evenodd">
            <g>
              <g>
                <path
                  fill="#DDDEE0"
                  d="M30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0zm0 7C17.297 7 7 17.297 7 30s10.297 23 23 23 23-10.297 23-23S42.703 7 30 7z"
                  transform="translate(-231 -293) translate(231 293)"
                />
                <path
                  fill="#364FC7"
                  d="M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7V0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30h7c0 12.703 10.297 23 23 23z"
                  transform="translate(-231 -293) translate(231 293)"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    open(rootId) {
      this.el = true;
      this.Id = rootId;
      this.isShowLoader = true;
    }
  },
  data() {
    return {
      el: null,
      isShowLoader: false,
      rootId: 'app'
    };
  }
};
</script>

<style lang="scss">
.loader-on #loading {
  pointer-events: unset !important;
}
.vld-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
  z-index: 9999;

  &.is-fixed {
    position: fixed;
  }

  &:focus {
    outline: none;
  }

  &.full {
    z-index: 9999;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .vld-background {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background-color: rgba($color--ui-01, 0.4);
    opacity: 0.4;
  }

  .vld-icon {
    position: relative;
    width: 60px;
    height: 60px;
  }
  .vld-parent {
    position: relative;
  }

  .s-loader {
    width: 60px;
    height: 60px;
    animation: load8 1s infinite linear;
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
